/*
Fa tutto GoogleTagManager:
- inizializzazione di GTAG
- gestione di GA (Google Analytics) (pertanto il codice di GA (UA-XXXXXXXXX-X) va inserito su GoogleTagManager)
*/

import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
// import { useLocation } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import {
  usePanelConfigAndPreferences,
  GDPRCookies,
} from 'volto-gdpr-privacy/helpers';

const gtmCode = __CLIENT__
  ? window?.env?.RAZZLE_GTM_CODE || process.env.RAZZLE_GTM_CODE
  : process.env.RAZZLE_GTM_CODE;

const GoogleTagManager = () => {
  // const location = useLocation();
  const cookies = new GDPRCookies();
  const { defaultPreferences } = usePanelConfigAndPreferences(cookies);
  //const [firstLoad, setFirstLoad] = useState(true);
  const consentADS = useSelector(
    (state) =>
      state.gdprPrivacyConsent.preferences?.GOOGLE_ADS ??
      defaultPreferences?.GOOGLE_ADS ??
      false,
  );

  const consentAnalytics = useSelector(
    (state) =>
      state.gdprPrivacyConsent.preferences?.GANALYTICS ??
      defaultPreferences?.GANALYTICS ??
      false,
  );

  const gtmInitialized = useRef(false);
  /**
   * 1️⃣ Init Consent Mode (PRIMA di GTM)
   */
  useEffect(() => {
    if (!__CLIENT__ || !gtmCode) return;
    console.log('GTM Init Consent Mode');
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function () {
        window.dataLayer.push(arguments);
      };

    window.gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied',
    });
  }, []);

  /**
   * 2️⃣ Load GTM (una sola volta)
   */
  useEffect(() => {
    if (!__CLIENT__ || !gtmCode || gtmInitialized.current) return;
    console.log('GTM Initialize');
    TagManager.initialize({
      gtmId: gtmCode,
    });

    gtmInitialized.current = true;
  }, []);

  // // Inizializzazione GTM con consent default
  // useEffect(() => {
  //   console.log('GTMCode:', gtmCode);
  //   if (gtmCode) {
  //     // console.log('GTM initialize');
  //     // TagManager.dataLayer({ dataLayer: ['set', 'url_passthrough', true] }); //Per i tag Google Ads e Floodlight e Analystics, se non è gia impostato in analytics - Lo impostano da TagManger / Analytics
  //     TagManager.initialize({
  //       gtmId: gtmCode,
  //       dataLayer: {
  //         event: 'default_consent',
  //         ad_storage: consentADS ? 'granted' : 'denied',
  //         ad_user_data: consentADS ? 'granted' : 'denied',
  //         ad_personalization: consentADS ? 'granted' : 'denied',
  //         analytics_storage: consentAnalytics ? 'granted' : 'denied',
  //       },
  //     });
  //   }
  //   setFirstLoad(false);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  /**
   * 3️⃣ Update consent quando cambiano le preferenze
   */
  useEffect(() => {
    if (!__CLIENT__ || !window.gtag) return;
    window.gtag('consent', 'update', {
      ad_storage: consentADS ? 'granted' : 'denied',
      ad_user_data: consentADS ? 'granted' : 'denied',
      ad_personalization: consentADS ? 'granted' : 'denied',
      analytics_storage: consentAnalytics ? 'granted' : 'denied',
    });
  }, [consentADS, consentAnalytics]);

  return <></>;
};

export default GoogleTagManager;
